"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.number.constructor");
var _vuex = require("vuex");
var _DragDialog = _interopRequireDefault(require("@/components/DragDialog"));
var _blExchangeAppointment = require("@/api/blExchangeAppointment/blExchangeAppointment");
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: "batchReservationSk",
  components: {
    dragDialog: _DragDialog.default
  },
  props: {
    edoCreditId: {
      type: String,
      default: ''
    },
    cancelEdoCreditIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    vvLBlNo: {
      type: String,
      default: ""
    },
    paymentStatus: {
      type: Number,
      default: 0
    },
    forespeakStatus: {
      type: Number,
      default: 0
    },
    forespeakBlNo: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    del: {
      type: String,
      default: ""
    },
    vvls: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    paymentStatusList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    forespeakStatusList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      form: {
        doType: 0
      },
      showSave: true,
      showCancel: true,
      cancelForespeakBatchVisible: false,
      cancelForespeakBatchMsg: ''
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])),
  created: function created() {},
  methods: {
    handleCloseCnacelBatch: function handleCloseCnacelBatch() {
      this.cancelForespeakBatchMsg = '';
      this.cancelForespeakBatchVisible = false;
    },
    handleCancel: function handleCancel() {
      var _this = this;
      if (this.form.edoCreditId) {
        this.loading = (0, _utils.load)();
        (0, _blExchangeAppointment.cancelForespeak)(this.form.edoCreditId).then(function (res) {
          if (res.success) {
            _this.form = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this.form), res.data);
            _this.$message({
              message: _this.$t('blExchangeAppointment.cancelReservationSuccess'),
              type: 'success'
            });
            _this.closed();
          } else {
            _this.$message.error(_this.$t('blExchangeAppointment.cancelReservationFail'));
          }
          _this.closed();
        }).catch(function (err) {}).finally(function () {
          _this.loading.close();
        });
      } else if (this.cancelEdoCreditIds) {
        this.loading = (0, _utils.load)();
        (0, _blExchangeAppointment.cancelForespeakBatch)(this.cancelEdoCreditIds).then(function (res) {
          if (res.data) {
            _this.cancelForespeakBatchMsg = res.data;
            _this.cancelForespeakBatchVisible = true;
          } else {
            _this.$message({
              message: _this.$t('blExchangeAppointment.cancelReservationSuccess'),
              type: 'success'
            });
          }
          _this.closed();
        }).catch(function (err) {}).finally(function () {
          _this.loading.close();
        });
      }
    },
    handleSave: function handleSave() {
      var _this2 = this;
      this.loading = (0, _utils.load)();
      this.form.forespeakBlNo = this.forespeakBlNo;
      (0, _blExchangeAppointment.saveForespeak)(this.form).then(function (res) {
        if (res.success) {
          _this2.$message({
            message: _this2.$t('blExchangeAppointment.reservationSuccessful'),
            type: 'success'
          });
          _this2.closed();
        } else {
          _this2.$message.error(_this2.$t('blExchangeAppointment.reservationFailure'));
        }
      }).finally(function () {
        _this2.loading.close();
      });
    },
    opened: function opened() {
      var _this3 = this;
      this.form = {
        doType: 0
      };
      if (this.edoCreditId) {
        // 单条记录，可以预约、取消预约
        this.showSave = true;
        this.showCancel = true;
        this.loading = (0, _utils.load)();
        (0, _blExchangeAppointment.getForespeakAction)(this.edoCreditId, 'CNSHK').then(function (res) {
          if (res.success) {
            res.data.doType = Number(res.data.doType);
            _this3.form = res.data;
            _this3.form.vvls = [res.data.inVesselCode + "," + res.data.inVoyageNo + res.data.inVoyageLeg];
          }
        }).catch(function (error) {}).finally(function () {
          _this3.loading.close();
        });
      } else {
        if (this.cancelEdoCreditIds && this.cancelEdoCreditIds.length > 0) {
          // 批量取消预约
          this.showSave = false;
          this.showCancel = true;
        } else {
          // 批量预约
          this.showSave = true;
          this.showCancel = false;
          this.form.del = this.del;
          this.form.vvls = this.vvls;
        }
        this.$set(this.form, 'paymentStatus', this.paymentStatus);
        this.$set(this.form, 'forespeakStatus', this.forespeakStatus);
      }
    },
    handleClear: function handleClear() {},
    closed: function closed() {
      var _this4 = this;
      this.$nextTick(function () {
        _this4.$refs.form.resetFields();
      });
      this.$emit('handleCloseReservationSk');
    },
    handleInitEdit: function handleInitEdit() {}
  }
};